import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface VerifiedArtistPrivileges {
  max_tracks: number;
  high_quality_uploads: boolean;
  pre_release_scheduling: boolean;
  collaboration_features: boolean;
  verified_community_access: boolean;
  fan_club_creation: boolean;

  priority_support: boolean;
  album_creation: boolean;
}

export function useVerifiedArtistPrivileges(artistId?: string) {
  const { data: privileges, isLoading } = useQuery({
    queryKey: ["verifiedArtistPrivileges", artistId],
    queryFn: async () => {
      if (!artistId) return null;

      const { data, error } = await supabase.rpc(
        "get_verified_artist_privileges",
        {
          p_artist_id: artistId,
        },
      );

      if (error) {
        console.error("Error fetching verified artist privileges:", error);
        return null;
      }

      return data as unknown as VerifiedArtistPrivileges;
    },
    enabled: !!artistId,
  });

  return {
    privileges,
    isLoading,
    isVerified: privileges?.high_quality_uploads || false,
  };
}
